import "./slider.css";
import SlickSlider from "react-slick";
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import bidingimg from "../../myimgs/Rectangle30.png";
import Swal from "sweetalert2";

const PropertySlider = () => {
  const [propertyCards, setPropertyCards] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const userId = localStorage.getItem("userId");

  const toggleFavorite = async (propertyId) => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      Swal.fire({
        title: "Login Required",
        text: "Please login first to add properties to your favorites.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#3085d6",
      });
      return;
    }

    setFavorites((prev) =>
      prev.includes(propertyId)
        ? prev.filter((favId) => favId !== propertyId)
        : [...prev, propertyId]
    );

    try {
      const baseURL = process.env.REACT_APP_API_BASE_URL;
      const response = await axios.post(
        `${baseURL}/favorites/${propertyId}?userId=${userId}`
      );

      if (response.status === 200) {
        console.log("Favorite updated successfully:", response.data);
      } else {
        console.warn(
          "Favorite API returned unexpected status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error updating favorite:", error);
    }
  };

  const outerSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const innerSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
  };

  const [countdowns, setCountdowns] = useState({});
  const navigate = useNavigate();

const handleViewDetails = (id, propeId) => {
    const url = `/propertyDetail?id=${id}&propeId=${propeId}`;
    window.open(url, "_blank");
  };

  const requestBody = {
    isApproved: true,
    page: 0,
    size: 30,
    sell: false,
    currentUser: userId,
  };
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await fetch(`${baseUrl}/property/list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });

        const data = await response.json();
        if (data.data.content) {
          const properties = data.data.content.filter(
            (item) => item.biddingDetails !== null
          );

          setPropertyCards(properties);

          // favorites logic same rahega
          const favIds = properties
            .filter((item) => item.favorite === true)
            .map((item) => item.id);

          setFavorites(favIds);
        } else {
          console.error("API response invalid:", data);
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
      } finally {
        setLoading(false); // stop loader once data loaded
      }
    };

    fetchProperties();
  }, []);

  // Optimized Countdown
  function Countdown({ start, end }) {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
      const interval = setInterval(() => setNow(Date.now()), 1000);
      return () => clearInterval(interval);
    }, []);

    const timeLeft = useMemo(() => {
      if (!start || !end) return "";

      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();

      if (isNaN(startTime) || isNaN(endTime)) return "";

      if (now < startTime) {
        const diff = startTime - now;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        return `Starts In: ${days}D : ${hours}H : ${minutes}M : ${seconds}S`;
      }

      if (now >= startTime && now < endTime) {
        const diff = endTime - now;
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        return `Ends In: ${days}D : ${hours}H : ${minutes}M : ${seconds}S`;
      }

      return "Offer Ended";
    }, [now, start, end]);

    return <h3>{timeLeft}</h3>;
  }

  // If still loading, show animation
  if (loading) {
    return (
      <div className="slider-loader">
        <div className="spinner"></div>
        <p>Loading properties...</p>
      </div>
    );
  }

  return (
    <section className="recommended-section" style={{ marginTop: "27px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold remd">Exclusive Offers Available in Your Area</h2>
        </div>

        <SlickSlider {...outerSettings}>
          {propertyCards.map((card, index) => {
            const images =
              card.propertyImages && card.propertyImages.length > 0
                ? card.propertyImages
                : [{ imageUrl: bidingimg }];

            const address = `${card.streetAddress || ""}, ${card.city || ""}, ${
              card.state || ""
            } ${card.zipcode || ""}`;

            const price = card?.biddingDetails?.listPrice || card.propertyValue;

            return (
              <div key={index} className="px-2">
                <div className="property-card">
                  <div className="property-image position-relative">
                    <SlickSlider {...innerSettings}>
                      {images.map((img, i) => (
                        <div key={i}>
                          <img
                            src={img.imageUrl}
                            alt={`property-${card.id}-${i}`}
                            className="img-fluid rounded-top"
                            style={{
                              height: "250px",
                              objectFit: "cover",
                              width: "100%",
                            }}
                          />
                        </div>
                      ))}
                    </SlickSlider>

                    <div className="position-absolute top-0 start-0 bg-dark text-white px-2 py-1 small m-2 rounded">
                      {card.propertieCategory || "Property"}
                    </div>

                    <div
                      className="fav-icon position-absolute top-0 end-0 m-2"
                      onClick={() => toggleFavorite(card.id)}
                      style={{
                        cursor: "pointer",
                        borderRadius: "50%",
                        padding: "6px",
                      }}
                    >
                      <i
                        className={`fa${
                          favorites.includes(card.id) ? "s" : "r"
                        } fa-heart`}
                        style={{
                          color: favorites.includes(card.id) ? "red" : "#ccc",
                          fontSize: "27px",
                          transition: "color 0.2s ease",
                        }}
                      ></i>
                    </div>
                  </div>
                  <div className="auctions-info">
                    <div className="auctions-details">
                      {card.user?.propertyType && (
                        <h1 className="listed-by">{card.user?.propertyType}</h1>
                      )}

                      {(card.listingId || card.propeId) && (
                        <h3 className="mls">
                          <strong>MLS No:</strong>{" "}
                          {card.listingId || card.propeId}
                        </h3>
                      )}

                      {card.user?.name && (
                        <p className="listed-by">
                          Listed by <span>{card.user?.name}</span>
                        </p>
                      )}
                      <h3 className="address">
                        {card.unparsedAddress || "No Address"}
                      </h3>
                      <div className="property-specs">
                        {card.bedroomsTotal && (
                          <span className="spec">
                            🛏{card.bedroomsTotal}bed
                          </span>
                        )}

                        {card.bathroomsTotalInteger && (
                          <span className="spec">
                            🛁{card.bathroomsTotalInteger}bath
                          </span>
                        )}

                        {card.lotSizeArea && (
                          <span className="spec">
                            📐{card.lotSizeArea}ft²
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="bgfix">
                    <div className="CURENTS">
                      <div className="price-section">
                        {/* <p className="price-label">Current Valuation</p> */}
                      </div>
                      <h4 className="prices">
                        {(() => {
                          if (card.liveBid) {
                            return `$${Number(card.liveBid).toLocaleString()}`;
                          }

                          const details = card.biddingDetails;

                          if (!details) {
                            return `$${
                              card.desiredPropertyValue?.toLocaleString() ||
                              "N/A"
                            }`;
                          }

                          const { currenntAuctionAmount, bidStartingValue } =
                            details;

                          if (
                            currenntAuctionAmount !== null &&
                            currenntAuctionAmount !== undefined
                          ) {
                            return `$${Number(
                              currenntAuctionAmount
                            ).toLocaleString()}`;
                          }

                          if (
                            bidStartingValue !== null &&
                            bidStartingValue !== undefined
                          ) {
                            return `$${Number(
                              bidStartingValue
                            ).toLocaleString()}`;
                          }

                          return "$N/A";
                        })()}
                      </h4>
                    </div>

                    <div className="timebtn">
                      <Countdown
                        start={card.biddingDetails?.bidingStartDateTime}
                        end={card.biddingDetails?.bidingEndDateTime}
                      />
                      <button
                          className="view-btn"
                          onClick={() => {
                            handleViewDetails(card.id, card.propeId);
                          }}
                        >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </SlickSlider>
      </div>
    </section>
  );
};

export default PropertySlider;
